import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { AgencyRevenueCostsPage } from '@/features/agency';
import { formatDocumentTitle } from '@/lib/document-title';

/** Agency ADMIN only: the page shows members an access notice and the API answers them 403. */
export const Route = createFileRoute('/_auth/agency/revenue-costs')({
  component: AgencyRevenueCostsRoute,
});

function AgencyRevenueCostsRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Revenue & Costs')}</title>
      </Helmet>
      <AgencyRevenueCostsPage />
    </>
  );
}
